import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../common/context/AuthContext';
import SecondaryButton from '../../buttons/SecondaryButton';
import PrimaryHeadline from '../../texts/PrimaryHeadline';
import PrimaryText from '../../texts/PrimaryText';
import PrimaryTitle from '../../texts/PrimaryTitle';
import { AccountCreationViewProps } from '../types';

const NewUserFlow: FC<AccountCreationViewProps> = (props) => {
	const { isAuthenticated, isOnboarded } = useAuthContext();
	const { t } = useTranslation();

	const handleNext = () => {
		console.debug('🚀 [NEW_USER_FLOW] User proceeding from NewUserFlow to brand selection');
		props.handleNextStep?.();
	};

	return (
		<div className="pop-flex pop-flex-col pop-justify-between pop-h-full pop-px-6 pop-py-10 pop-fadeIn">
			{/* Block 1: Top Title */}
			<div>
				<PrimaryTitle className="pop-text-center">
					{t('welcome_back')}
				</PrimaryTitle>
			</div>

			{/* Block 2: Middle Headline + Text */}
      <div className="pop-flex pop-flex-col pop-items-center">
        <PrimaryHeadline className="pop-text-center pop-text-popsizePrimary20 pop-my-4">
          {t('create_fashion_profile_message_1')}
        </PrimaryHeadline>
        <PrimaryText className="pop-text-center pop-my-2">
          {t('create_fashion_profile_message_2')}
        </PrimaryText>
      </div>


			{/* Block 3: Bottom Button + Duration */}
			<div className="pop-w-full pop-flex pop-flex-col pop-items-center pop-gap-2">

				<SecondaryButton
					className="pop-w-full pop-bg-popsizeGradientSecondary9050 pop-border-none pop-text-white"
					onClick={handleNext}
				>
					{t('intro_screen_3_go')}
				</SecondaryButton>
			</div>
		</div>
	);
};

export default NewUserFlow;
